export default __webpack_public_path__ + "src/assets/app-store-badge.a835a4e9d26b24f8d8bf8d7d7bd31ccb.png";